module.exports = __webpack_public_path__ + "static/FraktionMono-Medium-701f895c4f8834136e902d9c58726ea5.eot";